(function () {
    'use strict';

    angular.module('GorillaBoy.directives')
    .directive('gbProfileInput',
        ['$rootScope', 'MessageProvider', 'SignalProvider', 'authenticatedUser', 'MessageManager', 'AppConstants', 'AuthService',
        function ($rootScope, MessageProvider, SignalProvider, authenticatedUser, MessageManager, AppConstants, AuthService) {
        return {
            restrict: 'E',
            scope: true,
            link: function ($scope, element, attrs) {                
                $scope.$on(SignalProvider.Profile.UpdatePhotoUploadUrl, function($event, $data) {
                    AuthService.getUserInfo(true)
                    .then(function(userInfo) {
                        $('#id_profile_photo').fileupload({
                            url: userInfo.ProfilePhotoMetadata.ProfilePhotoUploadUrl,
                            // upload via PUT
                            type: AppConstants.HttpMethods.PUT,
                            // Disable multipart form uploads. If internet explorer, set to true to submit form data
                            multipart: false,
                            // The jQuery object for the file input field to listen on.
                            fileInput: $('#id_profile_photo'),
                            // Enable server-side encryption for all S3 uploads
                            headers: userInfo.ProfilePhotoMetadata.ProfilePhotoUploadSignedHeaders,
                            dropZone: null,
                            add: function (event, data) {
                                data.paramName = "File";
                                data.submit();
                                return true;
                            },
                            submit: function (e, data) {
                                return true;
                            },
                            fail: function (e, data) {
                                var res = data._response.jqXHR;
                                if (res.status === 403 &&  res.responseText && res.responseText.indexOf('Access Denied') >= 0) {
                                    MessageManager.addErrorMessage(MessageProvider.profileUpdatePhotoFailKmsError(window.location.hostname));
                                    $rootScope.metricServiceInstance.newCounterMetric('ProfileInput.Error.' + res.status + '.KMS.PhotoUpload');
                                } else {
                                    MessageManager.addErrorMessage(MessageProvider.profileUpdateFailDefault);
                                    $rootScope.metricServiceInstance.newCounterMetric('ProfileInput.Error.' + res.status + '.PhotoUpload');
                                }
                            },
                            done: function (event, data) {
                                $rootScope.$broadcast(SignalProvider.Profile.PhotoUpdated, data);

                                MessageManager.addSuccessMessage(MessageProvider.profileUpdatePhotoSuccess);
                            }
                        });                        
                    }, function() {
                        MessageManager.addErrorMessage(MessageProvider.profileUpdateFailDefault);
                    });
                });
            },
            template:
                '<div class="link-button">' +
                    '<label for="id_profile_photo" class="upload-photo-button">{{profile.profileText}}</label>' +
                    '<input tabindex="-1" id="id_profile_photo" name="files[]" type="file" class="hidden" accept=".png,.jpg,.jpeg">' +
                '</div>'
        };
    }]);
}());
